/* import { apollo } from '@iez/lib'
import { getQuery } from '@iez/lib/api/get-result/get'
 */
const returning = ({ root, ids }) =>
  ids.map(id => ({
    id,
    __typename: root
  }))
  /* items
    ? items.map(item => ({
      ...item,
      __typename: root
    })) : (() => {
      const query = getQuery({ root, fields })
      const cache = apollo.readQuery({
        query,
        variables
      })
      return cache[root]
    })() */

export default ({ root, ids }) => ({
  [`delete_${root}`]: {
    returning: returning({ root, ids }),
    __typename: `${root}_mutation_response`
  }
})
